import {createPopper} from '@popperjs/core';
import tippy from 'tippy.js';
window.tippy = tippy;

import './alpine.breakpoints';
import './alpine.screen';
import './alpine.tooltip';
import './search';
import './searchTariffs';
import './header';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'

window.vpWidth = window.innerWidth || document.documentElement.clientWidth;
Alpine.plugin(collapse);
Alpine.plugin(focus);
window.Alpine = Alpine;
Alpine.start();

/**
 * app.main
 */
const main = async (err) => {
  if (err) {
    // handle hmr errors
    console.error(err);
  }

  // application code
};

/**
 * Wait for the DOM to be ready before executing any code
 */
if (document.readyState === 'complete') {
  domIsReady();
} else {
  document.addEventListener('DOMContentLoaded', domIsReady);
}

/**
 * Add your custom code here that you want to run when the DOM is ready
 */
function domIsReady () {
  main().catch((err) => {
    console.error('Error in app.main:', err);
  });
}
